/*
 * @Author: changdou.fe@bytedance.com
 * @Date: 2026-04-01 22:35:06
 * @LastEditors: changdou.fe@bytedance.com
 * @LastEditTime: 2026-04-01 23:47:36
 */
import { ChainInfo } from '@/lib/okx-api';
import CoImage from '@/components/co-image';
import './index.scss';
export default function Chain(
  props: ChainInfo & {
    width?: number;
    height?: number;
    showName?: boolean;
    light?: boolean;
    gap?: number;
    className?: string;
  }
) {
  const { width = 28, height = 28, showName = false, light = false, gap = 2, className = '' } = props;
  return (
    <div className={`c-chain ${light ? 'light' : ''} flex items-center gap-${gap} ${className || ''}`}>
      <CoImage src={props.img} alt={props.chainName} width={width} height={height} className="c-chain-logo" />
      {showName && <span className="c-chain-name text-sm">{props.chainName}</span>}
    </div>
  );
}
